import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { withRouter } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { getLocaleUrlPath } from 'utils';
import { LOCALE } from 'constants/index';
var APP_META_TAGS = [process.env.APP_DISABLE_CRAWLING === 'true' ? {
  name: 'robots',
  content: 'noindex, nofollow'
} : {}];
var APP_BODY_ATTRIBUTES = {};
var AppHelmet = /*#__PURE__*/memo(function (_ref) {
  var location = _ref.location;

  var _useIntl = useIntl(),
      locale = _useIntl.locale;

  return /*#__PURE__*/_jsx(Helmet, {
    htmlAttributes: {
      lang: locale
    },
    meta: APP_META_TAGS,
    link: [{
      rel: 'alternate',
      hreflang: LOCALE.uk,
      href: "".concat(process.env.APP_MINFIN_DOMAIN, "/ua").concat(process.env.APP_ROUTER_BASENAME).concat(location.pathname).concat(location.search)
    }, {
      rel: 'alternate',
      hreflang: LOCALE.ru,
      href: "".concat(process.env.APP_MINFIN_DOMAIN).concat(process.env.APP_ROUTER_BASENAME).concat(location.pathname).concat(location.search)
    }, {
      rel: 'canonical',
      href: "".concat(process.env.APP_MINFIN_DOMAIN).concat(getLocaleUrlPath(locale)).concat(process.env.APP_ROUTER_BASENAME).concat(location.pathname)
    }],
    bodyAttributes: APP_BODY_ATTRIBUTES
  });
});
export default withRouter(AppHelmet);